<script>
    import Calculator from './Calculator.vue';
    import Comparator from './Comparator.vue';

    export default {
        components: { Comparator, Calculator },
        data: () => ({
            currentTool: 1,
            tabs: true,
            currentStep: 1,
        }),
        computed: {

        },
        methods: {
            toggleTabs(){
                this.tabs = !this.tabs
            },
            handleProgressbar(){
                this.toggleTabs()
                if (this.currentStep === 2) {
                    this.currentStep--
                    return
                }
                this.currentStep++
            },
            handleTools(id){
                this.currentTool = id
            }
        }
    }

</script>
<template>
    <div class="pt-10 pb-20" id="app">
        <router-view />
    </div>
</template>